<mat-icon [class.is-selected]="selected"
          class="check-selected mat-elevation-z2"
          matRipple>check</mat-icon>
<mat-card [class.is-selected]="selected"
          [class.mat-elevation-z5]="selected"
          matRipple>
    <mat-card-header>
        <mat-icon *ngIf="matIcon"
                  mat-card-avatar>{{ matIcon }}</mat-icon>
        <mat-icon *ngIf="svgIcon"
                  [svgIcon]="svgIcon"
                  mat-card-avatar>
        </mat-icon>
        <mat-card-title *ngIf="title"
                        [matTooltip]="title">
            {{ title }}
        </mat-card-title>
        <mat-card-subtitle *ngIf="subtitle"
                           [matTooltip]="subtitle">
            {{ safeSubtitle }}
        </mat-card-subtitle>
    </mat-card-header>
</mat-card>
